export const paginationOptions = [
  { text: '10 / стр.', value: 10 },
  { text: '20 / стр.', value: 20 },
  { text: '30 / стр.', value: 30 },
  { text: '40 / стр.', value: 40 },
  { text: '50 / стр.', value: 50 },
  { text: '100 / стр.', value: 100 }
]
